import type { FC } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Box } from "@similarweb/ui-components/foundations";

import { FormFieldLabel, RangeSelectWithFilter } from "app/pages/sales-intelligence/common-components/form-fields";
import FilterClearButton from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/FilterClearButton";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { RANGE_SELECT_WIDTH } from "../../../../../constants";
import type FindAppsRatingFilter from "../../../../../models/RatingFilter/RatingFilter";
import { formatNumber } from "../../utils";

export const NumberOfRatings: FC<IFilterViewBaseProps<FindAppsRatingFilter>> = ({ filter, onFilterUpdate, value }) => {
    const { translate } = useTranslate();

    const handleChange = ([minValue, maxValue]: Array<number | undefined>) => {
        onFilterUpdate({ ...value, numberOfRatings: { from: minValue, to: maxValue } });
    };

    const handleClear = () => {
        onFilterUpdate(value?.score ? { score: value.score } : undefined);
    };

    const isValueSet = !is.undefined(value?.numberOfRatings?.from) || !is.undefined(value?.numberOfRatings?.to);

    return (
        <Box marginY="16px 0">
            <FormFieldLabel text={translate("si.find_apps.filters.rating.number_of_ratings.heading")}>
                <RangeSelectWithFilter
                    fieldName="rating"
                    value={[value?.numberOfRatings?.from, value?.numberOfRatings?.to]}
                    optionsMin={filter.minOptions}
                    optionsMax={filter.maxOptions}
                    placeholderMin={translate("si.find_apps.filters.range.min.placeholder")}
                    placeholderMax={translate("si.find_apps.filters.range.max.placeholder")}
                    formatValue={formatNumber}
                    onChange={handleChange}
                    width={RANGE_SELECT_WIDTH}
                >
                    <FilterClearButton
                        onClick={handleClear}
                        isDisabled={!isValueSet}
                    />
                </RangeSelectWithFilter>
            </FormFieldLabel>
        </Box>
    );
};
